import Header from '../components/Header';
import Slider from '../components/Slider';
import About from '../components/About';
import Focus from '../components/Focus';
import Impact from '../components/Impact';
import GetInvolved from '../components/GetInvolved';
import Footer from '../components/Footer';
import ContactUs from '../components/Contact';
import ImageGallery from '../components/ImageGallery';

function Homepage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div id="home">
        <Slider/>
      </div>
      <div id="about">
        <About />
      </div>
      <div id="focus">
        <Focus/>
      </div>
      <div id="impact">
        <Impact/>
      </div>
      <div id="imageGallery">
        <ImageGallery/>
      </div>
      <div id="get-involved">
        <GetInvolved/>
      </div>
      <div id="contact">
        <ContactUs/>
      </div>
      <Footer/>
    </div>
  );
}

export default Homepage;